import { useToast } from '@blofin/blofin-ui';
import { useTranslations } from 'next-intl';
import { useCallback } from 'react';

const SHARE_CHANNELS = [
  { icon: 'icon-link', action: 'copy' },
  { icon: 'icon-twitter', action: 'twitter' },
  { icon: 'icon-facebook-fill', action: 'facebook' },
  { icon: 'icon-telegram', action: 'telegram' },
] as const;

function getShareUrl(action: string) {
  const url = encodeURIComponent(window.location.href);
  const title = encodeURIComponent(document.title);
  switch (action) {
    case 'twitter':
      return `https://x.com/intent/tweet?url=${url}&text=${title}`;
    case 'facebook':
      return `https://www.facebook.com/sharer/sharer.php?u=${url}`;
    case 'telegram':
      return `https://t.me/share/url?url=${url}&text=${title}`;
    default:
      return '';
  }
}

export default function ShareButton() {
  const t = useTranslations('support');
  const tc = useTranslations('common');
  const { methods: toast } = useToast();

  const handleClick = useCallback(
    (action: string) => {
      if (action === 'copy') {
        navigator.clipboard?.writeText(window.location.href);
        toast.success(tc('copySuccess'));
      } else {
        window.open(getShareUrl(action), '_blank', 'noopener,noreferrer');
      }
    },
    [toast, tc]
  );

  return (
    <div className="flex flex-col gap-4">
      <h3 className="text-xl font-bold leading-[30px] text-base-label">{t('share')}</h3>
      <div className="flex items-center gap-3">
        {SHARE_CHANNELS.map((channel) => (
          <button
            key={channel.action}
            type="button"
            onClick={() => handleClick(channel.action)}
            className="flex size-9 items-center justify-center rounded-full bg-base-hover-fill-secondary transition-colors hover:bg-base-fill-tertiary"
          >
            <i className={`iconfont ${channel.icon} text-xl text-base-label`} />
          </button>
        ))}
      </div>
    </div>
  );
}
